"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticleSpecs = void 0;
/**
 * Defines the ArticleSpecs (multi-selection possible)
 */
var ArticleSpecs;
(function (ArticleSpecs) {
    // espool-related
    ArticleSpecs["espoolOnly"] = "espoolOnly";
    ArticleSpecs["espoolReady"] = "espoolReady";
    // leitung-related
    ArticleSpecs["Chainflex"] = "Chainflex";
    ArticleSpecs["Readycable"] = "Readycable";
    ArticleSpecs["PullWire"] = "PullWire";
    ArticleSpecs["erkReady"] = "erkReady";
    // rolEchain-related
    ArticleSpecs["rolEchain"] = "rolEchain";
    ArticleSpecs["rolEchainOnly"] = "rolEchainOnly";
    ArticleSpecs["rolEchainRolLink"] = "rolEchainRolLink";
    ArticleSpecs["rolEchainAdapterLink"] = "rolEchainAdapterLink";
    ArticleSpecs["rolEchainModifiedLink"] = "rolEchainModifiedLink";
    ArticleSpecs["rolEchainAutoglideLink"] = "rolEchainAutoglideLink";
    // smartPlastics-related
    ArticleSpecs["smartPlasticsOnly"] = "SmartPlasticsOnly";
    ArticleSpecs["smartPlasticsECPSensor"] = "SmartPlasticsECPSensor";
    ArticleSpecs["smartPlasticsECPDummy"] = "SmartPlasticsECPDummy";
    ArticleSpecs["smartPlasticsModule"] = "SmartPlasticsModule";
    ArticleSpecs["smartPlasticsSMSModule"] = "SmartPlasticsSMSModule";
    ArticleSpecs["smartPlasticsSimCard"] = "SmartPlasticsSimCard";
})(ArticleSpecs = exports.ArticleSpecs || (exports.ArticleSpecs = {}));
//# sourceMappingURL=ArticleSpecs.js.map